import { Circle } from "@gigpro/ui/Icons";
import { Skeleton } from "@gigpro/ui/Skeleton";
import { formatDate } from "@gigpro/utils/datetime";
import { formatDistanceStrict } from "date-fns";
import React from "react";
import { times } from "remeda";

export type PROfileExperienceProps = {
  data: {
    start_date: Date;
    end_date: Date;
    by_position: Record<string, Record<string, { start_date: Date; end_date: Date }>>;
  };
};

export const PROfileExperience: React.FC<PROfileExperienceProps> = ({
  data: { start_date, end_date, by_position },
}) => {
  const positions = Object.entries(by_position);
  return (
    <>
      <h2 className="profile-title flex justify-between text-large font-semibold @sm/profile:text-extraLarge">
        Experience {!!positions.length && <span>{formatDistanceStrict(end_date, start_date)}</span>}
      </h2>
      {positions.length ? (
        positions.map(([position, experience]) => (
          <React.Fragment key={position}>
            <h3 className="mt-3 mb-2 text-normal font-semibold @sm/profile:text-large">{position}</h3>
            <ul className="flex flex-col gap-3">
              {Object.entries(experience).map(([business_name, { start_date, end_date }]) => (
                <li key={business_name} className="grid grid-cols-[min-content_1fr] items-center gap-x-2 gap-y-0.5">
                  <Circle className="row-span-2 size-1.5 text-gray" />
                  <p className="text-normal @sm/profile:text-large">
                    {business_name} - {formatDistanceStrict(end_date, start_date)}
                  </p>
                  <p className="text-normal text-gray @sm/profile:text-large">
                    {formatDate(start_date, "MMM yyyy")} - {formatDate(end_date, "MMM yyyy")}
                  </p>
                </li>
              ))}
            </ul>
          </React.Fragment>
        ))
      ) : (
        <p className="mt-2 text-medium-gray">This pro has not submitted their experience.</p>
      )}
    </>
  );
};

export function PROfileExperienceSkeleton() {
  return (
    <>
      <h2 className="profile-title flex justify-between text-large font-semibold @sm/profile:text-extraLarge">
        Experience <Skeleton className="w-10" />
      </h2>
      <Skeleton className="mt-3 mb-2 w-20 text-normal @sm/profile:text-large" />
      <ul className="flex flex-col gap-3">
        {times(2, (i) => (
          <li key={i} className="grid grid-cols-[min-content_1fr] items-center gap-x-2 gap-y-0.5">
            <Skeleton variant="circle" className="row-span-2 size-1.5" />
            <Skeleton className="w-28 text-normal @sm/profile:text-large" />
            <Skeleton className="w-24 text-normal @sm/profile:text-large" />
          </li>
        ))}
      </ul>
    </>
  );
}
